import { render } from "./ForgotPasswordPage.vue?vue&type=template&id=4767a45b&scoped=true"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=js"

import "./ForgotPasswordPage.vue?vue&type=style&index=0&id=4767a45b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4767a45b"]])

export default __exports__